import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=49d198dd&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49d198dd')) {
      api.createRecord('49d198dd', component.options)
    } else {
      api.reload('49d198dd', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=49d198dd&", function () {
      api.rerender('49d198dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k9cxPCNEdpbi/JS/comp/childrenage.vue"
export default component.exports